<template>
  <div class="jersey-numbers-color">
    <ColorPicker
      :value="letterNumberArtwork.color"
      :colors="colors"
      show-color-label
      @change="handleSelect"
    >
      <template #picker-preview="{ color }">
        <div
          :class="pickerStyle"
          :style="{ color: color?.hex || color || letterNumberArtwork.color }"
        >
          12345<br />67890
        </div>
      </template>
    </ColorPicker>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ColorPicker from "components/jiffy/vue-product-details-dtf/ColorPicker.vue";
import { useDtfStore } from "../store";

const colors = [
  { name: "Black", value: "#000000" },
  { name: "White", value: "#FFFFFF" },
  { name: "Navy", value: "#03283A" },
  { name: "Red", value: "#D50132" },
  { name: "Gold", value: "#FCA311" },
  { name: "Green", value: "#016B3F" },
  { name: "Purple", value: "#514689" },
  { name: "Royal", value: "#082D99" },
  { name: "Gray", value: "#82878D" },
  { name: "Columbia", value: "#6887B7" },
  { name: "Orange", value: "#F14329" },
  { name: "Vegas Gold", value: "#ABA275" },
  { name: "Yellow", value: "#F8DC02" }
];

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);
const pickerStyle = computed(() => ({
  "jersey-numbers-color__picker": true,
  "jersey-numbers-color__picker--solid": letterNumberArtwork.value.style === "solid"
}));

const handleSelect = color => {
  store.updateArtworkValues({ index: 0, color });
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.jersey-numbers-color {
  position: relative;

  &__picker {
    text-align: center;
    font-family: "Emilio 20";
    font-size: 60px;
    line-height: 1.3;
    margin: -16px 0 8px;

    @include with-tablet {
      font-size: 47px;
      margin: -16px 0 0;
    }

    &--solid {
      font-family: "Emilio 19";
    }
  }

  .color-picker__modal {
    @include with-tablet {
      top: auto;
      left: auto;
      margin-left: unset;
    }
  }
}
</style>
